import * as React from 'react';
import { SVGProps } from 'react';

const IconEraseSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m1.3 8.808 1.899 1.9a1 1 0 0 0 .707.292H11v-1H7.339L10.7 6.638c.4-.399.4-1.046 0-1.446L7.809 2.3c-.4-.4-1.047-.4-1.446 0L1.3 7.362c-.4.399-.4 1.046 0 1.446Zm2.246-2.28-1.54 1.54a.026.026 0 0 0-.004.008.025.025 0 0 0-.002.009c0 .004 0 .007.002.009l.005.007L3.906 10h2.019l.546-.546-2.925-2.925Z"
    />
  </svg>
);
export default IconEraseSizeXs;
